module.exports = __webpack_public_path__ + "img/7.76c0908d.png";